'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CmsAction = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CallToAction = require('components/CallToAction');

var _actions = require('components/CallToAction/actions');

var actions = _interopRequireWildcard(_actions);

var _constants = require('./constants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CmsAction = exports.CmsAction = function (_PureComponent) {
  (0, _inherits3.default)(CmsAction, _PureComponent);

  function CmsAction() {
    (0, _classCallCheck3.default)(this, CmsAction);
    return (0, _possibleConstructorReturn3.default)(this, (CmsAction.__proto__ || (0, _getPrototypeOf2.default)(CmsAction)).apply(this, arguments));
  }

  (0, _createClass3.default)(CmsAction, [{
    key: 'addActionProps',
    value: function addActionProps(action, value) {
      var _mapActionsToProps;

      var mapActionsToProps = (_mapActionsToProps = {}, (0, _defineProperty3.default)(_mapActionsToProps, _CallToAction.ACTIONS.LINK, { to: value }), (0, _defineProperty3.default)(_mapActionsToProps, _CallToAction.ACTIONS.OFFER_CHECKOUT, { promotionAlias: value }), (0, _defineProperty3.default)(_mapActionsToProps, _CallToAction.ACTIONS.SHOW_MODAL, {
        modalName: 'YouTubeVideoModal',
        modalProps: { videoId: value }
      }), _mapActionsToProps);
      return mapActionsToProps[action];
    }
  }, {
    key: 'renderAction',
    value: function renderAction(mappedAction) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;
      var actionValue = props.actionValue,
          children = props.children,
          extraProps = (0, _objectWithoutProperties3.default)(props, ['actionValue', 'children']);


      var Component = actions[mappedAction];

      if (!Component || !children) {
        return null;
      }

      return _react2.default.createElement(
        Component,
        (0, _extends3.default)({}, extraProps, this.addActionProps(mappedAction, actionValue)),
        children
      );
    }
  }, {
    key: 'render',
    value: function render() {
      switch (this.props.actionType) {
        case _constants.CMS_ACTION_TYPES.OFFER_CHECKOUT:
          return this.renderAction(_CallToAction.ACTIONS.OFFER_CHECKOUT);
        case _constants.CMS_ACTION_TYPES.RAF:
          return this.renderAction(_CallToAction.ACTIONS.SHOW_FRIENDBUY_WIDGET);
        case _constants.CMS_ACTION_TYPES.YOUTUBE_VIDEO:
          return this.renderAction(_CallToAction.ACTIONS.SHOW_MODAL);
        case _constants.CMS_ACTION_TYPES.URL:
          return this.renderAction(_CallToAction.ACTIONS.LINK);
        default:
          return null;
      }
    }
  }]);
  return CmsAction;
}(_react.PureComponent);

CmsAction.propTypes = {
  actionType: _propTypes2.default.string.isRequired,
  actionValue: _propTypes2.default.string,
  children: _propTypes2.default.node,
  onClick: _propTypes2.default.func
};